<template>
  <Snackbar class="root" :show="show">
    <div class="snackbar-body">
      <i class="af" :class="{ 'af-checkmark': !isRemoved, 'icon-color': !isRemoved, 'af-garbage': isRemoved }"></i>
      <span class="text">{{ message }}</span>
      <button v-if="isRemoved" :disabled="isAddingCart" @click.stop="onAddToCart" class="small" aria-label="Undo removal from cart">Undo</button>
    </div>
  </Snackbar>
</template>

<script>
import { ref, computed } from 'vue';
import { Snackbar } from '@/pixel/index';
import useAddToCart from '@/compositions/useAddToCart.js';

const SNACKBAR_DURATION = { added: 3000, removed: 5000 };

const show = ref(false);
const product = ref({});
const isRemoved = ref(false);

let onAddToCartCallback;
let previousTimeout;

export function showCartSnackbar(_product, removed = false, onAddToCart = () => {}) {
  product.value = _product.productTitle ? { ..._product, title: _product.productTitle } : _product;
  isRemoved.value = removed;
  show.value = true;

  if (previousTimeout) clearTimeout(previousTimeout);

  previousTimeout = setTimeout(hideSnackbar, removed ? SNACKBAR_DURATION.removed : SNACKBAR_DURATION.added);

  onAddToCartCallback = onAddToCart;
}

function hideSnackbar() {
  isRemoved.value = false;
  product.value = {};
  show.value = false;
}

export default {
  name: 'CartSnackbar',
  components: { Snackbar },
  setup() {
    const { addCartProcess, isAddingCart } = useAddToCart();

    const message = computed(() => {
      return `${product.value.title} ${isRemoved.value ? 'removed from' : 'added to'} the cart`;
    });

    async function onAddToCart() {
      await addCartProcess({
        products: [{ id: product.value.productId, quantity: product.value.quantity }],
      });

      if (typeof onAddToCartCallback === 'function') onAddToCartCallback();

      hideSnackbar();
    }

    return {
      show,
      message,
      product,
      isRemoved,
      isAddingCart,
      onAddToCart,
    };
  },
};
</script>

<style lang="postcss" scoped>
@import '@/pixel/style/variables';
.root {
  z-index: 2147483640; /* 1 more than the z-index of chat */

  .snackbar-body {
    width: 100%;
    display: flex;
    align-items: center;

    button {
      max-width: 90px;
    }

    .icon-color {
      color: var(--green);
    }

    .text {
      flex-grow: 1;
      padding: 0px 16px;
    }
  }
}
</style>
